import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';
import { LinkDetail, LinkInput, LinkSummary, PagingResponse, TagFilter } from '../models/cms-models';

@Injectable({
  providedIn: 'root',
})
export class LinksService {
  private apiService = inject(ApiService);

  async getSiteLinks(siteId: string, filter?: TagFilter): Promise<LinkSummary[]> {
    const response = await this.apiService.get<PagingResponse<LinkSummary>>(
      `api/link/site/${siteId}`,
      this.buildTagQuery(filter),
    );
    return response.data;
  }

  async getLink(linkId: string): Promise<LinkDetail> {
    return this.apiService.get<LinkDetail>(`api/link/${linkId}`);
  }

  async createLink(link: LinkInput): Promise<LinkDetail> {
    return this.apiService.post<LinkDetail, LinkInput>('api/link', link);
  }

  async updateLink(linkId: string, link: LinkInput): Promise<LinkDetail> {
    return this.apiService.put<LinkDetail, LinkInput>(`api/link/${linkId}`, link);
  }

  async deleteLink(linkId: string): Promise<void> {
    await this.apiService.delete(`api/link/${linkId}`);
  }

  private buildTagQuery(filter?: TagFilter): Record<string, string | string[]> | undefined {
    if (!filter || !filter.tags.length) {
      return undefined;
    }

    return {
      tags: filter.tags,
      tagMode: filter.tagMode,
    };
  }
}
